import React from "react";
export const ContinentsContext = React.createContext();
